import React, { Component } from "react";
import { ReactComponent as IconExtraInfo } from "../../resources/image/ic_extra_info.svg";

class Adapter extends Component {
  state = {
  };

  render() {
    const { extraInfo, title } = this.props;

    return (

      <div style={{ textAlign: "right" }} >

        <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right" , marginBottom: 10}}>
          <IconExtraInfo
            className="p-0"
            width="25"
            height="25"
          />
          <span style={{ fontSize: 13, color: "dimgrey", marginRight: 6 }}>{title}</span>

        </div>
        <div  
          style={{ fontSize: 13, color: "black" , whiteSpace: "pre-line", lineHeight: 1.6}}>
        {extraInfo}

        </div>

      </div>
    );
  }
}

export default Adapter;
